var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-field"},[_c(_vm.component,{tag:"component",attrs:{"id":_vm.custom.idCustomField,"label":_vm.custom.label,"augmenters":_vm.augmenters.timestamp,"options":_vm.options},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }